<template v-if="$parent.isModalVisible2" lang="pug">
div.h-100(name='modal3')
  .modal-mask.h-100(v-on:mousedown.self="$emit('close')")
    transition(name='slide-fade')
      .modal-container.col-12.h-100.m-0(v-if='$parent.isModalVisible3')
        .modal-header
          slot(name='header3')
            h2 Модальное окно второго уровня
          span.btn-close.btn-right.border-0.bg-transparent.text-center(type='button' v-on:click='$parent.closeModal3' aria-label='Close modal' style='padding:5px 10px;cursor:pointer;')
            i.fas.fa-times
        div(v-bind:class="['modal-body']")
          slot(name='body3')
        div(v-bind:class="['modal-footer']")
          slot(name='footer3')
</template>
<script>/* eslint-disable */
  export default {
    data () {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal3.vue